module.exports = __webpack_public_path__ + "img/邀請好友.8f77dc77.png";